import { useState, useEffect } from "react";
import newRequest from "../../../../utils/newRequest";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
// import "./Silder.css";
import { useTranslation } from "react-i18next";

const AddCardsection = ({ isVisible, setVisibility, refreshBrandData }) => {
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [Title, setTitle] = useState("");
  const [title_ar, setTitle_ar] = useState("");
  const [Caption, setCaption] = useState("");
  const [caption_ar, setCaption_ar] = useState("");
  const [Description, setDescription] = useState("");
  const [description_ar, setDescription_ar] = useState("");
  const [Buttonstatus, setButtonstatus] = useState("");
  const [Page, setPage] = useState("");
  // const [sliderPdf, setSliderPdf] = useState("");
  const [Pagedropdown, setPagedropdown] = useState([]);

  const handleCloseCreatePopup = () => {
    setVisibility(false);
  };
  const { t, i18n } = useTranslation();

  const [selectedFile, setSelectedFile] = useState(null);
  const [imageshow, setimageshow] = useState("");
  const [selectedFile_ar, setSelectedFile_ar] = useState(null);
  const [imageshow_ar, setimageshow_ar] = useState("");

  function handleChangeback(e) {
    setSelectedFile(e.target.files[0]);
    setimageshow(e.target.files[0]);
  }

  function handleChangeback_ar(e) {
    setSelectedFile_ar(e.target.files[0]);
    setimageshow_ar(e.target.files[0]);
  }

  useEffect(() => {
    const getpagedata = async () => {
      try {
        const response = await newRequest.get("/blogs/pages");
        const nameEnArray = response.data;
        setPagedropdown(nameEnArray);
      } catch (error) {
        // console.log(error);
      }
    };

    getpagedata();
  }, []);

  const handleAddCompany = async () => {
    const formData = new FormData();
    formData.append("title", Title);
    formData.append("title_ar", title_ar);
    formData.append("caption", Caption);
    formData.append("caption_ar", caption_ar);
    formData.append("description", Description);
    formData.append("description_ar", description_ar);
    formData.append("image", imageshow);
    // formData.append("button", Buttonstatus);
    formData.append("url", 'Page');
    formData.append("status", 1);
    // formData.append('pdf', sliderPdf);
    try {
      const response = await newRequest.post("/creatcards1", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage(
        `${t("Card")} ${Title} ${t("has been added successfully")}.`
      );
      // console.log(response.data);
      refreshBrandData();
      handleCloseCreatePopup();
    } catch (error) {
      setError(error?.response?.data?.error || "Error");
    }
  };

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  return (
    <div>
      {message && (
        <CustomSnakebar
          message={message}
          severity="success"
          onClose={resetSnakeBarMessages}
        />
      )}
      {error && (
        <CustomSnakebar
          message={error}
          severity="error"
          onClose={resetSnakeBarMessages}
        />
      )}
      {/* create the post api popup */}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full "
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Add")} {t("Card")}{" "}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="title"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title")}
                    </label>
                    <input
                      type="text"
                      id="title"
                      value={Title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Title_ar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title Arabic")}
                    </label>
                    <input
                      type="text"
                      id="Title_ar"
                      value={title_ar}
                      onChange={(e) => setTitle_ar(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="status"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Set Page")}
                    </label>
                    <select
                      id="status"
                      value={Page}
                      onChange={(e) => setPage(e.target.value)}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      <option value="Select">-- {t("Select")} --</option>
                      {Pagedropdown &&
                        Pagedropdown.map((itme, index) => {
                          return (
                            <option key={index} value={itme.slug}>
                              {itme.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="field1"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("English Caption")}
                    </label>
                    <input
                      type="text"
                      id="Caption"
                      value={Caption}
                      onChange={(e) => setCaption(e.target.value)}
                      placeholder={`${t("Enter")}${t("English Caption")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Captionar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Caption Arabic")}
                    </label>
                    <input
                      type="text"
                      id="Captionar"
                      value={caption_ar}
                      onChange={(e) => setCaption_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Caption Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="description"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      type="text"
                      id="description"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder={`${t("Enter")}${t("Description")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="descriptionar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description Arabic")}
                    </label>
                    <textarea
                      type="text"
                      id="descriptionar"
                      value={description_ar}
                      onChange={(e) => setDescription_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Description Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  {/* <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Button"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Button")}
                    </label>
                    <input
                      type="text"
                      id="Button"
                      value={Buttonstatus}
                      onChange={(e) => setButtonstatus(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Button text")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div> */}

                  <div className="flex justify-between flex-col sm:flex-row">
                    <div className="printerPic font-body sm:text-base text-sm flex flex-col gap-2">
                      {/* <center> */}
                      <label
                        htmlFor="Image"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {t("Image")}
                      </label>
                      <div className="imgesection">
                        <img
                          src={
                            selectedFile
                              ? URL.createObjectURL(selectedFile)
                              : imageshow != null
                              ? imageshow
                              : ""
                          }
                          className="printerpic"
                          style={{
                            width:
                              selectedFile || imageshow ? "200px" : "200px",
                            height:
                              selectedFile || imageshow ? "200px" : "200px",
                          }}
                        />

                        <div className="row " htmlFor="file-inputs">
                          <label
                            htmlFor="file-inputs"
                            className="choosefile bg-secondary hover:bg-primary"
                          >
                            {t("choose file")}
                          </label>
                          <input
                            id="file-inputs"
                            type="file"
                            onChange={handleChangeback}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>

                      {/* </center> */}
                    </div>

                    {/* <div className="printerPic font-body sm:text-base text-sm flex flex-col gap-2">
                      <label
                        htmlFor="Imagear"
                        className={`text-secondary  ${
                          i18n.language === "ar" ? "text-end" : "text-start"
                        }`}
                      >
                        {t("Image Arabic")}
                      </label>
                      <div className="imgesection">
                        <img
                          src={
                            selectedFile_ar
                              ? URL.createObjectURL(selectedFile_ar)
                              : imageshow_ar != null
                              ? imageshow_ar
                              : ""
                          }
                          className="printerpic"
                          style={{
                            width:
                              selectedFile_ar || imageshow_ar
                                ? "200px"
                                : "200px",
                            height:
                              selectedFile_ar || imageshow_ar
                                ? "200px"
                                : "200px",
                          }}
                        />

                        <div className="row " htmlFor="imagear">
                          <label
                            htmlFor="imagear"
                            className="choosefile bg-secondary hover:bg-primary"
                          >
                            {t("choose file")}
                          </label>
                          <input
                            id="imagear"
                            type="file"
                            onChange={handleChangeback_ar}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseCreatePopup}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    onClick={handleAddCompany}
                    className="px-5 py-2 rounded-sm w-[70%] bg-secondary text-white font-body text-sm ml-2"
                  >
                    {t("Add")} {t("Card")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCardsection;
